import { FragmentOf } from "gql.tada";
import { BLOCKS } from "@contentful/rich-text-types";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { RichText } from "@components/shared/core/RichText";

export const CaseStudyExploreMore = ({
  data,
}: {
  data: FragmentOf<typeof RichEntryFragment> | null | undefined;
}) => {
  if (!data) return null;

  return (
    <section className="py-20 dsk:py-[120px] flex items-center justify-center">
      <div className="w-full max-w-[923px] flex flex-col items-center text-center text-neutral-cream">
        <RichText
          content={data}
          options={{
            renderNode: {
              [BLOCKS.PARAGRAPH]: (_, children) => (
                <CenteredBannerText>{children}</CenteredBannerText>
              ),
            },
          }}
        />
      </div>
    </section>
  );
};

const CenteredBannerText = ({ children }: { children: React.ReactNode }) => (
  <h2 className="text-neutral-cream font-['Netflix_Sans_Title'] font-medium text-[40px] dsk:text-[64px] leading-[0.94] tracking-[-0.02em] text-center max-w-[546px] [*+&]:mt-8">
    {children}
  </h2>
);
